import type { IMapFilter } from "../pages/maps/filters/filterContext";

import { BaseController } from "./baseController";

const controller = "MapV2";

export class MapController extends BaseController {
	static Get = BaseController.GetFn(controller);
	public static async getInitialFilters(entityType: string, entityId: string) {
		const result = await MapController.Get<IInitialMapFilter>("GetInitialFilters", {
			entityType,
			entityId,
		});

		if (result.error) throw result.error;

		return result;
	}

	public static async autocomplete(input: string) {
		return await MapController.Get<string[]>("Autocomplete", {
			input,
		});
	}

	public static async geocode(input: string) {
		return await MapController.Get<IGeocodeResult>("Geocode", {
			input,
		});
	}
}

export interface IGeocodeResult {
	lat: number;
	lng: number;
}

interface IInitialMapFilter extends IMapFilter {
	error: string;
}
